Service = App.loadClass 'core::Angular/Service'

class exports.PicsService extends Service
    constructor: (@http, @upload, @rootScope) ->
        undefined

    getPics: () =>
        @http.post 'backend/admin/pics/get-pics'

    addPic: (caption, file) =>
        @upload.upload
            url: 'backend/admin/pics/add-pic'
            data:
                file: file
                caption: caption
